import React, { useState, useRef, useEffect } from 'react';

export default function CustomSelect({ id, value, onChange, options, placeholder }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const selected = options.find((o) => o.value === value);

  const select = (val) => {
    onChange(val);
    setOpen(false);
  };

  const listboxId = id ? `${id}-options` : 'custom-select-options';

  return (
    <div
      id={id}
      className={`custom-select${open ? ' open' : ''}`}
      ref={ref}
      role="combobox"
      aria-haspopup="listbox"
      aria-expanded={open}
      aria-controls={listboxId}
      tabIndex={0}
      onClick={() => setOpen(!open)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen(!open); }
        if (e.key === 'Escape') setOpen(false);
      }}
    >
      <span className={!selected ? 'custom-select-placeholder' : ''}>
        {selected ? selected.label : (placeholder || 'Select one')}
      </span>
      <svg width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true">
        <path d="M1 1l5 5 5-5" stroke="#1a1a1a" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
      {open && (
        <div id={listboxId} className="custom-select-options" role="listbox">
          {options.map((o) => (
            <div
              key={o.value}
              className={`custom-select-option${value === o.value ? ' selected' : ''}`}
              role="option"
              aria-selected={value === o.value}
              tabIndex={0}
              onClick={(e) => { e.stopPropagation(); select(o.value); }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); select(o.value); }
              }}
            >
              {o.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
